import { epicRequest } from 'app'

export const PLAYER_DETAILS_FETCH = 'PLAYER_DETAILS_FETCH'
export const PLAYER_DETAILS_FETCH_ERROR = 'PLAYER_DETAILS_FETCH_ERROR'
export const PLAYER_DETAILS_FETCH_FULFILLED = 'PLAYER_DETAILS_FETCH_FULFILLED'
export const PLAYER_DETAILS_FETCH_CANCELED = 'PLAYER_DETAILS_FETCH_CANCELED'

export const PLAYER_DETAILS_INITIAL_STATE = {
  id: null,
  data: [],
  error: null,
  loading: false,
  tournamentId: null,
}

export const playerDetailsFetch = (playerId, tournamentId) => ({
  payload: {
    playerId,
    tournamentId,
  },
  type: PLAYER_DETAILS_FETCH,
})

export const playerDetailsFetchFulfilled = (payload) => ({
  payload,
  type: PLAYER_DETAILS_FETCH_FULFILLED,
})

export const playerDetailsFetchCanceled = () => ({
  payload: null,
  type: PLAYER_DETAILS_FETCH_CANCELED,
})

export const playerDetailsFetchError = (payload) => ({
  payload,
  type: PLAYER_DETAILS_FETCH_ERROR,
})

export const playerDetailsFetchEpic = epicRequest({
  actionType: PLAYER_DETAILS_FETCH,
  errorAction: playerDetailsFetchError,
  fulfilledAction: playerDetailsFetchFulfilled,
  request: ({ payload }) => `users/player/${payload.playerId}/tournament/${payload.tournamentId}`,
  untilTypes: PLAYER_DETAILS_FETCH_CANCELED,
})
